import ReactGA from "react-ga";

export const initGA = (trackingID) => {
  ReactGA.initialize(trackingID, {
    gaOptions: {
      siteSpeedSampleRate: 100
    }
  });
}

export const PageView = () => {
  ReactGA.pageview(window.location.pathname + window.location.search);
}

export const SetDimension = (dimension, dimensionValue) => {
  let dim = {};
  dim[dimension] = dimensionValue;
  ReactGA.set( dim );
}

export const SetUserId = (userId) => {
  ReactGA.set( {userId: userId} );
}

export const Event = (category, action, label, dimension="", dimensionValue="", value=0) => {
  // custom dimension for a given event
  if (dimension) {
    SetDimension(dimension, dimensionValue);
  }
  ReactGA.event({
    category: category,
    action: action,
    label: label,
    value: value
  });
};

export const Timing = (category, variable, value = 0, label = "") => {
  ReactGA.timing({
    category,
    variable,
    value, // in milliseconds
    label
  });
};

export const ModalView = (pseudoUrl) => {
  ReactGA.modalview(pseudoUrl);
};

// TODO: we can implement an outbound link tracking by using ReactGA.OutboundLink component
